<template>
  <div class="content">
    <!--搜索-->
    <el-container>
      <el-header :height="formHeight" ref="vHeader">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" ref="searchForm">
          <el-row>
            <el-form-item style="float: right; margin-top: -2px; margin-left: 20px">
              <el-link type="primary" :underline="false" @click="onCollapse" style="margin-right: 15px">{{ formHeight === "47px" ? "展开" : "折叠" }}</el-link>
              <el-button type="primary" @click="searchPage" class="green-btn">搜索</el-button>
              <el-button @click="resetForm" class="orange-btn">重置</el-button>
            </el-form-item>

            <el-form-item label="商品编码:" prop="skuCode">
              <el-input v-model.trim="searchForm.skuCode" placeholder="请输入商品编码"></el-input>
            </el-form-item>
            <el-form-item label="商品名称:" prop="skuName">
              <el-input v-model.trim="searchForm.skuName" placeholder="请输入商品名称"></el-input>
            </el-form-item>
            <el-form-item label="是否清仓:">
              <el-select v-model="searchForm.clearance" placeholder="全部">
                <el-option label="全部" value="" />
                <el-option label="是" value="是" />
                <el-option label="否" value="否" />
                <el-option label="-" value="-" />
              </el-select>
            </el-form-item>
            <span class="form-date-picker">
              <el-form-item label="更新时间:">
                <el-date-picker v-model="searchForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="至" class="date-picker-middle">
                <el-date-picker v-model="searchForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
              </el-form-item>
            </span>
            <el-form-item label="标签:">
              <el-select v-model="searchForm.changeFlag" placeholder="全部">
                <el-option label="全部" value="" />
                <el-option label="新增" value="0" />
                <el-option label="变更" value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="是否组合:">
              <el-select v-model="searchForm.isCombination" placeholder="全部">
                <el-option label="全部" value="" />
                <el-option label="是" value="Y" />
                <el-option label="否" value="N" />
              </el-select>
            </el-form-item>
          </el-row>
        </el-form>
      </el-header>

      <!--列表-->
      <el-main>
        <div style="margin-bottom: 10px; text-align: right">
          <el-button type="primary" size="mini" class="green-btn" @click="exportExcel">导出</el-button>
          <el-button type="primary" slot="reference" size="mini" @click="tableVisible = true">表格设置</el-button>
        </div>
        <el-table
          border
          ref="table"
          v-loading="loading"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          :height="tableHeight"
          :data="tableData.list"
          v-if="tableReload"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          :span-method="handleSpanMethod"
          style="width: 100%"
        >
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :min-width="item.width"
            :sortable="item.sortable ? 'custom' : false"
            :align="item.align"
            :fixed="item.fixed"
            show-overflow-tooltip
            v-for="item in columnData"
            :key="item.prop"
          >
            <template slot-scope="scope">
              <template v-if="item.label == '图片'">
                <el-button v-if="scope.row.imgUrlList.length" size="mini" type="text" @click="viewImg(scope.row)">查看</el-button>
              </template>
              <template v-else-if="item.label == '有效期'">
                <span>{{ scope.row.validtyStart }}<span v-if="scope.row.validtyStart && scope.row.validtyEnd">至</span>{{ scope.row.validtyEnd }}</span>
              </template>
              <template v-else>
                {{ scope.row[item.prop] }}
              </template>
            </template>
          </el-table-column>
          <el-table-column width="110" fixed="right" label="操作">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="lookRecord(scope.row)">查看调整记录</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div style="overflow: hidden">
          <el-pagination
            style="float: right; margin-top: 10px"
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </el-main>
    </el-container>

    <el-dialog title="商品销售价调整记录" width="80%" :visible.sync="recordFormVisible">
      <el-form :inline="true" class="dialog-form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品编码(SKU)：" label-width="164px">
              <div style="width: 100%">{{ recordInfo.skuCode }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="商品名称(SKU)：" label-width="164px">
              <div style="width: 100%">{{ recordInfo.skuName }}</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-container class="list-wrapper">
        <el-main class="table-wrap">
          <el-table
            :data="recordTableData.list"
            :header-cell-style="{ backgroundColor: '#F4F8FB' }"
            style="width: 100%"
            border
            element-loading-text="数据加载中"
            element-loading-spinner="el-icon-loading"
            :max-height="200"
          >
            <el-table-column :show-overflow-tooltip="true" prop="promotionPriceA" label="S级活动到手价"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="promotionPriceB" label="A级活动到手价" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="promotionPriceC" label="日常活动到手价" width="120"></el-table-column>
            <!-- <el-table-column :show-overflow-tooltip="true" prop="promotionRetailPrice" label="活动零售价"></el-table-column> -->
            <el-table-column :show-overflow-tooltip="true" prop="dailyRetailPrice" label="A类价"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="tagPrice" label="产品标价(划线价)"></el-table-column>
            <!-- <el-table-column :show-overflow-tooltip="true" prop="combinationPrice" label="组合sku折扣价"></el-table-column> -->
            <el-table-column :show-overflow-tooltip="true" prop="clearancePrice" label="清仓销售价"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="redEnvelopeOne" label="一段红包" width="80"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="redEnvelopeTwo" label="二段红包" width="80"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="redEnvelopeThree" label="三段红包" width="80"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="validityDateSection" label="有效期" width="160"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="adjustmentCause" label="调整原因"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="updateBy" label="更新人"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="updateDate" label="更新时间" width="160"></el-table-column>
          </el-table>
        </el-main>
        <el-footer height="64px" style="text-align: right; padding-top: 15px">
          <el-pagination
            @size-change="recordOnSizeChange"
            @current-change="recordOnCurrentChange"
            :current-page="recordTableData.pageNum"
            :page-sizes="[10, 30]"
            :page-size="recordTableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="recordTableData.total"
          ></el-pagination>
        </el-footer>
      </el-container>
    </el-dialog>

    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
    <custom-table v-model="tableVisible" :tableDataSet="tableDataSet" v-if="tableVisible" @closeAddForm="closeAddForm" @confirm="confirm"></custom-table>
  </div>
</template>

<script>
import imgShow from "@/views/components/imgShow";
import customProps from "./customProps.mixin";
import axios from "@/utils/axiosInstance";
import pagePathMixin from '@/utils/page-path-mixin'

export default {
  name: "PriceQuery",
  mixins: [customProps, pagePathMixin],
  components: { imgShow },
  data() {
    return {
      searchForm: {
        skuCode: "",
        skuName: "",
        changeFlag: "",
        clearance: "",
        isCombination: "",
      },
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      loading: false,
      styles: [],
      // tableHeight: null,
      imgFormVisible: false,
      imgList: [],
      // 调整记录
      recordFormVisible: false,
      recordTableData: {
        list: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      recordInfo: {
        skuCode: "",
        skuName: "",
      },
      formHeight: "47px",
    };
  },
  computed: {
    tableHeight() {
      if (this.formHeight === "47px") {
        return window.innerHeight - 223;
      } else {
        let formHeight = (this.$refs["vHeader"] && this.$refs["vHeader"].$el.offsetHeight) || 0;
        return window.innerHeight - formHeight - 223 + 47;
      }
    },
  },
  methods: {
    onCollapse() {
      if (this.formHeight === "47px") {
        this.formHeight = "auto";
      } else {
        this.formHeight = "47px";
      }
      this.tableReload = false;
      this.$nextTick((_) => {
        this.tableReload = true;
      });
    },
    lookRecord(row) {
      this.recordFormVisible = true;
      this.recordInfo.skuCode = row.goodsCode;
      this.recordInfo.skuName = row.goodsName;
      this.recordOnSearch();
    },
    recordOnSizeChange(pageSize) {
      this.recordTableData.pageSize = pageSize;
      this.recordTableData.pageNum = 1;
      this.recordOnSearch();
    },
    recordOnCurrentChange(pageNum) {
      this.recordTableData.pageNum = pageNum;
      this.recordOnSearch();
    },
    recordOnSearch() {
      // let param = {
      //   pageNum: this.recordTableData.pageNum,
      //   pageSize: this.recordTableData.pageSize,
      //   filterData: {
      //     skuCode: this.recordInfo.skuCode,
      //   },
      // };
      // this.$q.goods.listSalesPriceAdjustment({ data: param }).then((res) => {
      //   this.recordTableData = res.data;
      // });
      let data = {
        pageSize: this.recordTableData.pageSize,
        pageNum: this.recordTableData.pageNum,
        reportCode: "goodsPriceAdjustmentLog",
        queryMatch: [
          {
            attributeName: "goodsCode",
            val: this.recordInfo.skuCode,
            op: "=",
          },
        ],
        hasCount: "Y",
      };
      axios.post(`/ec-pc-api/custom/reports/data/goodsPriceAdjustmentLog`, data).then((res) => {
        if (res.code == 200) {
          this.recordTableData = res.data;
        }
      });
    },
    searchPage() {
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onSearch() {
      this.loading = true;
      // const { skuCode, skuName, clearance } = this.searchForm;
      const param = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          // skuCode: skuCode,
          // skuName: skuName,
          // clearance: clearance,
          ...this.searchForm,
        },
      };
      this.$q.goods
        .listPrice({
          data: param,
        })
        .then((res) => {
          if (res.code == 200 && res.data.records.length) {
            this.tableData = {
              ...res.data,
              list: this.formatTableData(res.data.records),
            };
          } else {
            this.tableData.list = [];
            this.tableData.total = 0;
          }
          this.loading = false;
        });
    },
    initSearchForm() {
      this.tableData.pageNum = 1;
      this.searchForm = {
        skuCode: "",
        skuName: "",
        changeFlag: "",
        clearance: "",
        isCombination: "",
      };
    },
    resetForm() {
      this.initSearchForm();
      this.$nextTick((_) => {
        this.onSearch();
      });
    },
    onSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.onSearch();
    },
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        taskDTO: {
          appCode: "ec-pc-new",
          paramMap: this.searchForm,
          reportName: "saleAllPriceExport",
        },
        columnDTOs: null,
      };
      let tmp = JSON.parse(JSON.stringify(this.columnData));

      params.columnDTOs = tmp
        .map((item) => {
          return {
            columnName: item.label,
            fieldName: item.prop,
            fieldType: "string",
            columnFormat: null,
          };
        })
        .filter((v) => v.columnName != "图片");
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
        } else {
          this.$message.error(res.message);
        }
      }).finally(_=>{
        loading.close()
      });
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 查看图片
    viewImg(row) {
      this.imgFormVisible = true;
      this.imgList = [];
      const list = row.imgUrlList;
      for (const item of list) {
        this.imgList.push(item.path);
      }
    },
    // tabldata 格式化 合并单元格
    formatTableData(data) {
      let list = [];
      data.forEach((v) => {
        if (v["goodsSaleList"].length) {
          let item = [];
          v["goodsSaleList"].forEach((k) => {
            let obj = k;
            obj["imgUrlList"] = v["imgUrlList"];
            obj["goodsCode"] = v["goodsCode"];
            obj["goodsName"] = v["goodsName"];
            item.push(obj);
          });
          list.push(...item);
        } else {
          list.push({
            imgUrlList: v["imgUrlList"],
            goodsCode: v["goodsCode"],
            goodsName: v["goodsName"],
            isAdd: "1",
          });
        }
      });
      return list;
    },
    // table 单元格合并
    handleSpanMethod({ row, column, rowIndex, columnIndex }) {
      let goodsCodeArr = this.tableData.records.map((v) => v["goodsCode"]);
      let arr = [];
      goodsCodeArr.forEach((item, index) => {
        if (index === 0) {
          arr.push({ goodsCode: 1 });
          return;
        }
        if (goodsCodeArr[index - 1] !== item) {
          arr.push({ goodsCode: 1 });
        } else {
          arr[arr.length - 1]["goodsCode"]++;
        }
      });
      let newArr = [];
      arr.forEach((item, index) => {
        if (item.goodsCode > 1) {
          newArr.push(item);
          for (let i = 1; i < item.goodsCode; i++) {
            newArr.push({ goodsCode: null });
          }
        } else {
          newArr.push(item);
        }
      });
      if (columnIndex < 3 || columnIndex === 14) {
        if (newArr[rowIndex]["goodsCode"]) {
          return {
            rowspan: newArr[rowIndex]["goodsCode"],
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
  },
  mounted() {
    // this.tableHeight = window.innerHeight - 286;
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.el-input-group__append button.el-button, .el-input-group__append div.el-select .el-input__inner, .el-input-group__append div.el-select:hover .el-input__inner, .el-input-group__prepend button.el-button, .el-input-group__prepend div.el-select .el-input__inner, .el-input-group__prepend div.el-select:hover .el-input__inner {
  border-color: #0BB78E;
  background-color: #0BB78E;
  color: #FFF;
  border-top: 0;
  border-bottom: 0;
}

.ant-divider, .ant-divider-vertical {
  position: relative;
  top: -0.06em;
  display: inline-block;
  width: 1px;
  height: 0.8em;
  margin: 0 6px;
  vertical-align: middle;
  background-color: #0BB78E;
}

.content {
  margin: 5px;

  >>> .el-header {
    border-radius: 5px
    padding: 8px 0 8px 8px;
    overflow: hidden;
    background: #fff;
  }

  >>> .el-main {
    background: #fff;
    border-radius: 5px;
    margin-top: 5px;
    padding: 10px;
  }

  >>> .el-form-item {
    margin-bottom: 10px;
  }
}

.search-container {
  overflow: hidden;
  margin-bottom: 10px;
  padding: 0 20px;

  >>> .el-form-item {
    margin-bottom: 0;
  }
}

.avatar-uploader {
  >>> .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border-color: #409EFF;
    }
  }
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

.upload-tip {
  margin-left: 30px;
  margin-top: -10px;
}

.preview-content {
  text-align: center;

  p {
    margin-bottom: 10px;
  }

  >>> .el-image {
    width: 200px;
    height: 200px;
  }
}

>>> .el-dialog__body {
  padding: 10px 15px;
}

>>> .el-table__expanded-cell {
  padding: 10px;
  background: rgb(250, 250, 250);
}

.dialog-footer {
  text-align: center;
}

>>> .input .el-input__inner {
  width: 150px;
  height: 28px;
}

// >>> .el-table__header-wrapper  .el-checkbox{ //隐藏全选
// display: none !important;
// }
>>> .saleLocation .el-form-item__label {
  width: 120px !important;
}

>>> .el-form .el-select__tags-text {
  display: inline-block;
  max-width: 93px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

>>> .el-select .el-tag__close.el-icon-close {
  top: -7px;
}

.table-wrap {
  padding: 10px;
}

.wrap_tooltip {
  display: inline-block;
  max-width: 200px; // 最大的宽度，必写属性
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.dialog-form {
  >>> .el-form-item {
    margin-bottom: 0px;
  }
}
</style>
